import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISchedule } from '../../../schedule/types/ISchedule';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { FlowOutputStep } from '../types/FlowOutputStep';
import { FlowOutputStepRun } from '../types/FlowOutputStepRun';
import { FlowRun } from '../types/FlowRun';
import { RunFlowTask } from '../types/RunFlowTask';

export type GetFlowOutputStepRunsParams = IGetItemsParams;

export type GetFlowOutputStepRunsResult = IGetItemsResult & {
  readonly flowOutputStepRuns: FlowOutputStepRun[];
  readonly flowRuns: FlowRun[];
  readonly runFlowTasks: RunFlowTask[];
  readonly schedules: ISchedule[];
  readonly flowOutputSteps: FlowOutputStep[];
  // readonly publishedDataSources: UnifiedDataSource[];
};

export class GetFlowOutputStepRunsRequest extends Request<GetFlowOutputStepRunsParams, GetFlowOutputStepRunsResult> {
  constructor(params: GetFlowOutputStepRunsParams) {
    super('getFlowOutputStepRuns', params);
  }
}
